export default __webpack_public_path__ + "static/media/suny.6d672288.png";